<template>
  <div class="dt-details cmp-distribution-order_details">
    <div
      class="dt-details--header"
      :class="{
        'dt-loading darken': selectedOrder.order_details_tab_summary_loading,
      }"
    >
      {{
        selectedOrder.order_details_tab_summary_loading
          ? `${this.$t("order_details")} ${this.$t("loading")}...`
          : `${selectedOrder.order_details_tab_summary.order.order_id} ${selectedOrder.order_details_tab_summary.order.order_type_name}`
      }}
      <span @click="onAccountClick"
        >{{
          selectedOrder.order_details_tab_summary_loading
            ? ""
            : selectedOrder.order_details_tab_summary.order.account_name
        }}
      </span>
    </div>
    <div
      class="dt-details--body"
      :class="{
        'dt-loading darken': selectedOrder.order_details_tab_summary_loading,
      }"
    >
      <div class="dt-details--col">
        <div class="dt-details--row">
          <TextField2
            v-if="selectedOrder.order_details_tab_summary_loading"
            :id="'account_name'"
            :placeholder="$t('account_name')"
            :label="$t('account_name')"
            :value="''"
            @change="onODTextFieldChange"
            lw="90px"
            cw="110px"
            bb="none"
            style="width: 100%"
            :disabled="true"
          />
          <div
            v-else
            class="fc2 valued disabled fc2-textfield"
            style="
              height: 32px;
              --fc2-lw: 90px;
              --fc2-cw: 110px;
              --fc2-height: 32px;
              --bb: none;
              width: 100%;
            "
            placeholder="Account Name"
          >
            <label class="fc2-label txtov" title="Account Name"
              ><span>{{$t('account_name')}}</span></label
            >
            <div
              @click="onAccountClick"
              class="ut-link ut-text-accent5 txtov"
              style="text-align: left; width: var(--fc2-cw); padding: 5px"
            >
              {{
                selectedOrder.order_details_tab_summary &&
                selectedOrder.order_details_tab_summary.order &&
                selectedOrder.order_details_tab_summary.order.account_name
              }}
            </div>
          </div>
        </div>
        <div class="dt-details--row">
          <TextField2
            :disabled="selectedOrder.order_details_tab_summary_loading"
            :id="'order_reference'"
            :placeholder="$t('Customer Ref')"
            :label="$t('Customer Ref')"
            :value="
              selectedOrder.order_details_tab_summary &&
              selectedOrder.order_details_tab_summary.order &&
              selectedOrder.order_details_tab_summary.order.order_reference
            "
            @change="onODTextFieldChange"
            lw="90px"
            cw="110px"
            bb="none"
            style="width: 100%"
          />
        </div>
        <div class="dt-details--row">
          <Dropdown2
            :disabled="selectedOrder.order_details_tab_summary_loading"
            :label="$t('Type')"
            :placeholder="'Select ' + $t('Type')"
            :options="orderTypeList"
            :selected="
              orderTypeList.find((e) =>
                e.value ==
                (selectedOrder.order_details_tab_summary &&
                  selectedOrder.order_details_tab_summary.order &&
                  selectedOrder.order_details_tab_summary.order.order_type)
                  ? selectedOrder.order_details_tab_summary.order.order_type
                  : undefined
              )
            "
            v-on:selectedChange="
              (e) => onOrderDetailsChange('order_type', e.value || '')
            "
            lw="90px"
            bb="none"
            style="width: 100%"
          />
        </div>
      </div>
      <div class="dt-details--col">
        <div class="dt-details--row">
          <DatePicker2
            :disabled="selectedOrder.order_details_tab_summary_loading"
            id="created"
            :label="$t('date')"
            :value="
              selectedOrder.order_details_tab_summary &&
              selectedOrder.order_details_tab_summary.order &&
              selectedOrder.order_details_tab_summary.order.order_date
                ? selectedOrder.order_details_tab_summary.order.order_date
                : undefined
            "
            @input="(e) => onOrderDetailsChange('order_date', e.value)"
            lw="72px"
            cw="110px"
            bb="none"
            style="width: 100%"
          />
        </div>
        <div class="dt-details--row">
          <Dropdown2
            :disabled="selectedOrder.order_details_tab_summary_loading"
            :label="$t('Status')"
            :placeholder="'Select ' + $t('Status')"
            :options="orderStatusList"
            :selected="
              orderStatusList.find((e) =>
                e.text ==
                (selectedOrder.order_details_tab_summary &&
                  selectedOrder.order_details_tab_summary.order &&
                  selectedOrder.order_details_tab_summary.order.status_name)
                  ? selectedOrder.order_details_tab_summary.order.status_name
                  : undefined
              )
            "
            v-on:selectedChange="
              (e) => onOrderDetailsChange('status_name', e.value || '')
            "
            lw="70px"
            bb="none"
            style="width: 100%"
          />
        </div>
        <div class="dt-details--row">
          <TextField2
            :disabled="selectedOrder.order_details_tab_summary_loading"
            :id="'order_source'"
            :placeholder="$t('Source')"
            :label="$t('Source')"
            :value="
              selectedOrder.order_details_tab_summary &&
              selectedOrder.order_details_tab_summary.order &&
              selectedOrder.order_details_tab_summary.order.order_source
            "
            @change="onODTextFieldChange"
            lw="72px"
            cw="110px"
            bb="none"
            style="width: 100%"
          />
        </div>
      </div>
      <div class="dt-details--col">
        <div class="dt-details--row">
          <Dropdown2
            :disabled="selectedOrder.order_details_tab_summary_loading"
            :label="$t('Invoice Project')"
            :placeholder="'Select ' + $t('invoice_project')"
            :options="invoiceProjectsList"
            :selected="
              invoiceProjectsList.find(
                (e) =>
                  `${e.value}` ==
                  `${
                    selectedOrder.order_details_tab_summary &&
                    selectedOrder.order_details_tab_summary.order &&
                    selectedOrder.order_details_tab_summary.order
                      .invoice_project_id
                  }`
              )
            "
            v-on:selectedChange="
              (e) => onOrderDetailsChange('invoice_project_id', e.value || '')
            "
            lw="90px"
            bb="none"
            style="width: 100%"
          />
        </div>
        <div class="dt-details--row">
          <Dropdown2
            :disabled="selectedOrder.order_details_tab_summary_loading"
            :label="$t('Currency')"
            :placeholder="'Select ' + $t('currency')"
            :options="currenciesList"
            :selected="
              currenciesList.find((e) =>
                e.value ==
                (selectedOrder.order_details_tab_summary &&
                  selectedOrder.order_details_tab_summary.order &&
                  selectedOrder.order_details_tab_summary.order.currency_id)
                  ? selectedOrder.order_details_tab_summary.order.currency_id
                  : undefined
              )
            "
            v-on:selectedChange="
              (e) => onOrderDetailsChange('currency_id', e.value || '')
            "
            lw="90px"
            bb="none"
            style="width: 100%"
          />
        </div>
        <div class="dt-details--row">
          <TextField2
            :disabled="selectedOrder.order_details_tab_summary_loading"
            :id="'price_list_name'"
            :placeholder="$t('price_list')"
            :label="$t('price_list')"
            :value="
              selectedOrder.order_details_tab_summary &&
              selectedOrder.order_details_tab_summary.order &&
              selectedOrder.order_details_tab_summary.order.price_list_name
            "
            @change="onODTextFieldChange"
            lw="90px"
            cw="110px"
            bb="none"
            style="width: 100%"
            
          />
        </div>
      </div>
      <div class="dt-details--col">
        <div class="dt-details--row">
          <Dropdown2
            :disabled="selectedOrder.order_details_tab_summary_loading"
            :label="$t('stock_account')"
            :placeholder="'Select ' + $t('stock_account')"
            :options="stockAccountList"
            :selected="
              stockAccountList.find((e) =>
                e.value ==
                (selectedOrder.order_details_tab_summary &&
                  selectedOrder.order_details_tab_summary.order &&
                  selectedOrder.order_details_tab_summary.order
                    .contra_account_id)
                  ? selectedOrder.order_details_tab_summary.order
                      .contra_account_id
                  : undefined
              )
            "
            v-on:selectedChange="
              (e) => onOrderDetailsChange('contra_account_id', e.value || '')
            "
            lw="105px"
            bb="none"
            style="width: 100%"
          />
        </div>
        <div class="dt-details--row">
          <Dropdown2
            :disabled="selectedOrder.order_details_tab_summary_loading"
            :label="$t('vat_handling')"
            :options="vatHandlingList"
            :selected="
              vatHandlingList.find((e) =>
                e.value ==
                (selectedOrder.order_details_tab_summary &&
                  selectedOrder.order_details_tab_summary.order &&
                  selectedOrder.order_details_tab_summary.order.vat_handling)
                  ? selectedOrder.order_details_tab_summary.order.vat_handling
                  : undefined
              )
            "
            v-on:selectedChange="
              (e) => onOrderDetailsChange('vat_handling', e.value || '')
            "
            lw="105px"
            bb="none"
            style="width: 100%"
          />
        </div>
        <div class="dt-details--row">
          <Dropdown2
            :disabled="selectedOrder.order_details_tab_summary_loading"
            :label="$t('payment_method')"
            :options="paymentMethodList"
            :selected="
              paymentMethodList.find((e) =>
                e.value ==
                (selectedOrder.order_details_tab_summary &&
                  selectedOrder.order_details_tab_summary.order &&
                  selectedOrder.order_details_tab_summary.order
                    .payment_method_id)
                  ? selectedOrder.order_details_tab_summary.order
                      .payment_method_id
                  : undefined
              )
            "
            v-on:selectedChange="
              (e) => onOrderDetailsChange('payment_method_id', e.value || '')
            "
            lw="105px"
            bb="none"
            style="width: 100%"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DistributionStoreNamespace as storeNS } from "../../store";
import { mapActions, mapGetters } from "vuex";
import * as ActionTypes from "../../store/types";
import EditableSpan from "@/plugins/editable-span/editable-span";
import { createDropdownConfig } from "@/plugins/dropdown";
import { createTextFieldConfig, EventHooks } from "@plugins/text-field";
import { mapGetterObject, mapActionObject } from "../../../../store/global";
import { distributionOrderGetters } from "../../store/orders/getters";
import { createTV } from "../../../../models/text-value.model";
import { distributionAccountListLDTRoutes } from "../../router/routes";
export default {
  components: {
    EditableSpan,
  },
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        validationEvent: EventHooks.OnBlur,
        valueChangedEvent: EventHooks.OnBlur,
      },
      dropdownConfig: createDropdownConfig({
        iconHoverStyle: 1,
      }),
      vatHandlingList: [
        {
          text: "VAT on top",
          value: 1,
        },
        {
          text: "Including VAT",
          value: 2,
        },
        {
          text: "No VAT",
          value: 3,
        },
      ],
    };
  },
  props: {
    selectedOrder: {
      type: Object,
    },
  },
  computed: {
    ...mapGetterObject(storeNS, distributionOrderGetters),
    orderStatusList: function () {
      console.log("::::", this.selectedOrder);
      return (
        createTV(
          this.selectedOrder?.order_details_tab_summary?.order_status,
          "value",
          "value"
        ) || []
      );
    },
    currenciesList: function () {
      return (
        createTV(
          this.selectedOrder?.order_details_tab_summary?.currencies,
          "currency_iso",
          "currency_id"
        ) || []
      );
    },
    invoiceProjectsList: function () {
      return (
        createTV(
          this.selectedOrder?.order_details_tab_summary?.invoice_projects,
          "invoice_project_name",
          "invoice_project_id"
        ) || []
      );
    },
    paymentMethodList: function () {
      return (
        createTV(
          this.selectedOrder?.order_details_tab_summary?.payment_methods,
          "payment_method_name",
          "payment_method_id"
        ) || []
      );
    },
    orderTypeList: function () {
      return (
        createTV(
          this.selectedOrder?.order_details_tab_summary?.order_types,
          "label",
          "value"
        ) || []
      );
    },
    stockAccountList: function () {
      return (
        createTV(
          this.selectedOrder?.order_details_tab_summary?.stock_accounts,
          "account_name",
          "account_id"
        ) || []
      );
    },
    channel_types: function () {
      return [
        { text: this.$t("physical"), value: 1 },
        { text: this.$t("digital"), value: 1 },
      ];
    },
    account_types: function () {
      return [];
    },
  },
  methods: {
    onAccountClick: function () {
      const { account_id } = this.selectedOrder.order_details_tab_summary.order;

      this.$router.push({
        name: distributionAccountListLDTRoutes.names.tab,
        params: {
          account_id: account_id,
          tab: "overview",
        },
      });
    },
    onOrderDetailsChange: function (name, value) {
      // console.log("name:value", name, value);
      this.$emit("updated", {
        name,
        value,
      });
    },

    onMainContactChange: function (name, value) {
      this.$emit("updated", {
        name,
        value,
      });
    },
    onODTextFieldChange({ name, value }) {
      this.$emit("updated", {
        name,
        value,
      });
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-distribution-order_details {
  min-height: 140px;
  .dt-details--row {
    padding-left: 0px !important;
    .link-5 {
      cursor: pointer;
      .fc-control {
        color: var(--bc-accent5);
        cursor: pointer;
      }
    }
  }
}
</style>

